import React from 'react';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import CenterPanelView from './centerPanelView';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function CallerEntryContent(props) {
  let centerPanel = {};

  let rightPanel = (
    <RightPanelTop
      waitingArea={props.waitingArea}
      callerEntryPointForm={props.callerEntryPointForm}
      messageData={props.messageData}
      updateOrView={props.updateOrView}
    />
  );
  console.log('inside caller entry');
  if (props.updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate waitingArea={props.waitingArea} callerEntryPointForm={props.callerEntryPointForm} />
    );
  } else {
    centerPanel = <CenterPanelView callerEntryPointForm={props.callerEntryPointForm} waitingArea={props.waitingArea} />;
  }
  // TODO - APP.LANGUAGE.CallerEntryModal.NewTitle is for now. It should eventually be consistent with CallerEntryModal.Title
  return (
    <Modal show={props.showCallerEntryModal} hideWhenClickAway={false} className="ui modal">
      <PopupHeader
        title={APP.LANGUAGE.CallerEntryModal.NewTitle}
        subtitle={props.waitingArea.name + ' (' + props.waitingArea.organisationName + ')'}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpURLToGivePeople}
      />
      <div className="content">
        <div className="main-ui-container caller-entry-point">
          <div id="righthandfloatingpanel" style={{ minHeight: '570px' }}>
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              {props.updateOrView == 'update' ? <RightPanelBottom waitingArea={props.waitingArea} /> : ''}
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              {props.updateOrView == 'update' ? <RightPanelBottom waitingArea={props.waitingArea} /> : ''}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
